import type { BadgeTone } from '@/components/ui/Badge';

/**
 * Matches docs/DESIGN_SYSTEM.md's 12-domain section-to-accent mapping
 * (Batch 5) — each category now gets its own identity rather than several
 * sharing one collapsed tone (e.g. AutoMod no longer reuses Security's red
 * outright; Moderation/Settings/Logs/Backups are no longer all one blue).
 */
export const categoryTone: Record<string, BadgeTone> = {
  Security: 'security',
  AutoMod: 'automod',
  Moderation: 'moderation',
  Community: 'community',
  Automation: 'automation',
  'Dem AI': 'ai',
  Tickets: 'tickets',
  Analytics: 'analytics',
  Settings: 'settings',
  Logging: 'logs',
  Backups: 'backups',
  Utility: 'neutral',
  Owner: 'settings',
  Help: 'help',
};

export function toneForCategory(category: string): BadgeTone {
  return categoryTone[category] ?? 'neutral';
}
